var _link, _style, _path, _use, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfArizona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "-288 -192 576 384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode",
    rel: "stylesheet",
    href: ""
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-288-192h576v384h-576z",
    fill: "#002868",
    style: {
      fill: "#002664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-288-192h576V0h-576z",
    fill: "#bf0a30",
    style: {
      fill: "#bb133e"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M288-147v80L0 0zm-149-45h83L0 0zm-112 0h48L0 0z",
    fill: "#fed700"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0-96 62.385 96l-163.07-119.42h201.38L-62.375 96z",
    fill: "#ce5c17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfArizona);
export default __webpack_public_path__ + "static/media/Flag_of_Arizona.9fcd156b05bc80c952e54cc01ae3399b.svg";
export { ForwardRef as ReactComponent };